/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestDev from '@/utils/requestDev'
import { APICore, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function actionStored(data) {
    return requestRaw({
        url: APICore() + '/brand/instagram_account/action_stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function detailEdit(id) {
    return requestRaw({
        url: APICore() + '/brand/instagram_account/detail_edit?id=' + id,
        method: 'GET',
    })
}
export function detail(id) {
    return requestRaw({
        url: APICore() + '/brand/instagram_account/detail?id=' + id,
        method: 'GET',
    })
}
export function create(data) {
    return requestRaw({
        url: APICore() + '/brand/instagram_account/create',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function update(data) {
    return requestRaw({
        url: APICore() + '/brand/instagram_account/update?id=' + data.id,
        method: 'POST',
        data: data // untuk array data post
    })
}
export function list(data) {
    return requestRaw({
        url: APICore() + '/brand/instagram_account/list-data',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function listOfficial(data) {
    return requestDev({
        url: APIReportPHP() + '/brand/instagram_account/list-data-official',
        method: 'POST',
        data: qs.stringify(data) // untuk array data post
    })
}


// WEBPACK FOOTER //
// ./src/api/instagramAccount.js